/**
 * @author: lv.chen
 * @date: 2025/4/1
 * @desc: Pipeline / Change Log / Change Checklist页面 Update状态标签组件
 */
import React from 'react';
import classnames from 'classnames';
import { ChangeCheckMemoStatus } from '@gp/enums/changeLog';

import type { IBaseProps } from '@home/types/common';

import './index.scss';

interface IPipelineChangeChecklistUpdateStatusTagProps extends IBaseProps {
  status?: ChangeCheckMemoStatus | null;
}

const PipelineChangeChecklistUpdateStatusTag: React.FC<IPipelineChangeChecklistUpdateStatusTagProps> = (props) => {
  const { style, className, status } = props;

  const isChecked = status === ChangeCheckMemoStatus.Checked;
  const statusText = isChecked ? 'Update' : 'Pending Update';

  return (
    <div
      style={style}
      className={classnames('dbg-pipeline-change-log-change-checklist-update-status-tag', className, {
        'is-pending': !isChecked,
        'is-updated': isChecked,
      })}
    >
      {statusText}
    </div>
  );
};

export default PipelineChangeChecklistUpdateStatusTag;
